/*
 * ITALIANO — Avviso Proprietario / Copyright & IP Notice (Ultra-Restrittivo)
 *
 *   Copyright (c) 2026.
 *
 *   Copyright © 2026 PhepTech di Pietro Guglielmi. Tutti i diritti riservati.
 *   Copyright © 2026 Pietro Guglielmi. Tutti i diritti riservati.
 *
 *   1) Natura proprietaria – Nessuna licenza
 *
 *   Questo software e tutto il relativo materiale (inclusi, a titolo esemplificativo e
 *   non esaustivo: codice sorgente e/o oggetto, file, moduli, classi, funzioni, metodi,
 *   algoritmi, strutture dati, architettura, API, interfacce, UI/UX, testi, grafica,
 *   risorse, configurazioni, build logic, documentazione, specifiche e ogni derivato)
 *   sono opera protetta e/o contenuto proprietario di Pietro Guglielmi e/o PhepTech di
 *   Pietro Guglielmi (“Titolare”).
 *
 *   Nessuna licenza o diritto d’uso è concesso con la sola disponibilità, visione,
 *   accesso, download, clonazione, consegna o possesso del Software, salvo quanto
 *   espressamente autorizzato per iscritto dal Titolare tramite contratto o licenza
 *   separata firmata.
 *
 *   Sono esclusi tutti i diritti impliciti, inclusi (senza limitazione) diritti per
 *   implicazione, consuetudine, “estoppel” o altrimenti.
 *
 *   2) Divieti assoluti (salvo autorizzazione scritta)
 *
 *   È severamente vietato, in tutto o in parte, e con qualsiasi mezzo o finalità
 *   (inclusa finalità didattica, commerciale o concorrente), salvo esplicita
 *   autorizzazione scritta del Titolare:
 *
 *   - copiare, riprodurre, trascrivere, pubblicare, caricare, trasmettere, distribuire,
 *     ridistribuire, condividere, cedere, vendere, sublicenziare, noleggiare, prestare o
 *     rendere disponibile a terzi il Software;
 *
 *   - modificare, adattare, tradurre, trasformare, creare opere derivate, integrare o
 *     incorporare in altri prodotti/servizi, o utilizzare il Software per creare o
 *     addestrare modelli, dataset, automazioni o strumenti (inclusi sistemi di AI/ML)
 *     che ne replichino funzionalità o valore;
 *
 *   - effettuare reverse engineering, decompilare, disassemblare, decodificare o
 *     tentare di ricavare il sorgente, le chiavi, le logiche o i meccanismi interni;
 *     aggirare, disattivare o eludere misure di sicurezza/controllo accessi/DRM o
 *     meccanismi di protezione;
 *
 *   - rimuovere, alterare o occultare avvisi di copyright, marchi, attribuzioni,
 *     watermark o indicazioni di riservatezza.
 *
 *   Eccezione obbligatoria: quanto sopra vale nella massima misura consentita dalla
 *   legge applicabile; eventuali usi consentiti imperativamente dalla legge restano
 *   limitati allo stretto necessario.
 *
 *   3) Riservatezza e segreti commerciali (se applicabile)
 *
 *   Nella misura in cui il Software o parti di esso non siano stati resi pubblicamente
 *   disponibili dal Titolare, essi costituiscono Informazioni Riservate e possono
 *   integrare segreti commerciali.
 *
 *   È obbligatorio adottare misure di protezione almeno ragionevoli e comunque non
 *   inferiori a quelle usate per proteggere i propri segreti commerciali, e non
 *   divulgarli a terzi.
 *
 *   4) Titolarità, feedback e diritti IP
 *
 *   Il Software è di esclusiva titolarità del Titolare. Tutti i diritti di proprietà
 *   intellettuale e industriale (copyright, know-how, segreti commerciali, diritti su
 *   banche dati, marchi, brevetti — ove applicabili) restano del Titolare.
 *
 *   Qualsiasi idea, segnalazione, proposta di miglioramento o feedback comunicato al
 *   Titolare potrà essere utilizzato liberamente dal Titolare senza obbligo di
 *   compenso, attribuzione o restrizioni, nella misura consentita dalla legge.
 *
 *   5) Tutela e rimedi
 *
 *   Qualsiasi violazione può causare un danno grave e irreparabile. Il Titolare potrà
 *   richiedere inibitoria immediata, sequestro, rimozione dei contenuti, risarcimento
 *   danni, restituzione dei profitti e ogni ulteriore rimedio previsto dalla legge,
 *   incluse (ove consentite) spese legali.
 *
 *   6) Esclusione di garanzie e limitazione di responsabilità
 *
 *   Il Software è fornito “così com’è” e “come disponibile”, senza garanzie di alcun
 *   tipo, espresse o implicite, incluse (senza limitazione) garanzie di commerciabilità,
 *   idoneità a scopo particolare, non violazione, accuratezza o assenza di errori.
 *
 *   Nella massima misura consentita dalla legge, il Titolare non sarà responsabile per
 *   danni indiretti, incidentali, consequenziali, speciali, punitivi, perdita di
 *   profitti, dati o interruzione attività.
 *
 *   7) Legge applicabile e foro
 *
 *   Salvo norme inderogabili, il presente avviso e qualsiasi uso/non-uso del Software
 *   sono regolati dalla legge italiana. Ogni controversia è devoluta in via esclusiva
 *   al Foro di [MILANO] (sostituisci se preferisci altro foro).
 *
 *   8) Protezione internazionale
 *
 *   Il Software è protetto a livello internazionale secondo i principi di tutela
 *   automatica e “national treatment” previsti da convenzioni e accordi internazionali
 *   in materia di diritto d’autore e proprietà intellettuale (es. Convenzione di Berna,
 *   TRIPS), nei rispettivi Paesi aderenti.
 *
 *
 *   ENGLISH — Proprietary Notice / Copyright & IP Notice (Ultra-Restrictive)
 *
 *   Copyright (c) 2026.
 *
 *   Copyright © 2026 PhepTech di Pietro Guglielmi. All rights reserved.
 *   Copyright © 2026 Pietro Guglielmi. All rights reserved.
 *
 *   1) Proprietary nature – No license granted
 *
 *   This software and all related materials (including, without limitation: source
 *   and/or object code, files, modules, classes, functions, methods, algorithms, data
 *   structures, architecture, APIs, interfaces, UI/UX, text, graphics, assets,
 *   configurations, build logic, documentation, specifications, and any derivatives)
 *   are proprietary to Pietro Guglielmi and/or PhepTech di Pietro Guglielmi (“Owner”)
 *   and are protected by applicable intellectual property laws.
 *
 *   No license or right is granted by mere access, viewing, possession, delivery,
 *   download, cloning, or use of the Software, unless expressly authorized in writing
 *   by the Owner under a separate signed agreement/license.
 *
 *   All implied licenses are expressly disclaimed, including by implication, custom,
 *   estoppel, or otherwise.
 *
 *   2) Strict prohibitions (unless prior written permission)
 *
 *   You are strictly prohibited, in whole or in part, by any means and for any purpose
 *   (including educational, commercial, or competitive purposes), unless you have the
 *   Owner’s prior written permission, from:
 *
 *   - copying, reproducing, publishing, uploading, transmitting, distributing,
 *     re-distributing, sharing, selling, assigning, sublicensing, renting, leasing,
 *     lending, or otherwise making the Software available to any third party;
 *
 *   - modifying, adapting, translating, transforming, creating derivative works,
 *     integrating, incorporating into other products/services, or using the Software to
 *     build or train models, datasets, automations, or tools (including AI/ML systems)
 *     that replicate its functionality or value;
 *
 *   - reverse engineering, decompiling, disassembling, decoding, or attempting to
 *     derive source code, keys, logic, internal mechanisms; bypassing, disabling, or
 *     circumventing security/access controls/DRM or other protection measures;
 *
 *   - removing, altering, or obscuring copyright notices, trademarks, attributions,
 *     watermarks, or confidentiality markings.
 *
 *   Mandatory legal carve-out: the above applies to the maximum extent permitted by
 *   applicable law; any non-waivable statutory rights remain limited to what the law
 *   strictly requires.
 *
 *   3) Confidentiality & trade secrets (where applicable)
 *
 *   To the extent the Software (or any portion thereof) has not been publicly disclosed
 *   by the Owner, it constitutes Confidential Information and may include trade
 *   secrets. You must protect it using at least reasonable safeguards and must not
 *   disclose it to any third party.
 *
 *   4) Ownership, feedback, and IP rights
 *
 *   The Software is exclusively owned by the Owner. All intellectual and industrial
 *   property rights (copyright, know-how, trade secrets, database rights, trademarks,
 *   patents—where applicable) remain with the Owner.
 *
 *   Any ideas, suggestions, improvements, or feedback you provide may be used by the
 *   Owner without compensation, attribution, or restrictions, to the extent permitted
 *   by law.
 *
 *   5) Enforcement & remedies
 *
 *   Any violation may cause irreparable harm. The Owner may seek immediate injunctive
 *   relief, takedowns, seizure/impoundment where available, damages, disgorgement of
 *   profits, and any other remedies allowed by law, including attorneys’ fees where
 *   permitted.
 *
 *   6) Disclaimer of warranties & limitation of liability
 *
 *   The Software is provided “AS IS” and “AS AVAILABLE”, without warranties of any
 *   kind, express or implied, including merchantability, fitness for a particular
 *   purpose, non-infringement, accuracy, or error-free operation.
 *
 *   To the maximum extent permitted by law, the Owner shall not be liable for indirect,
 *   incidental, consequential, special, exemplary, or punitive damages, loss of profits
 *   or data, or business interruption.
 *
 *   7) Governing law & jurisdiction
 *
 *   Except where mandatory law provides otherwise, this notice and any use/non-use of
 *   the Software shall be governed by the laws of Italy, with exclusive jurisdiction in
 *   the courts of [MILAN] (edit as desired).
 *
 *   8) International protection
 *
 *   The Software is protected internationally under the principles of automatic
 *   protection and national treatment reflected in major international copyright/IP
 *   frameworks (e.g., the Berne Convention and TRIPS), in their respective member
 *   countries.
 */

package com.pheptech.kmp.newborn.demo5.theme

import org.jetbrains.compose.web.css.*

object NewbornTheme {
    val primary = Color("#B19470")
    val secondary = Color("#2C3E50")
    val background = Color("#FAFAFA")
    val surface = Color("#FFFFFF")
    val textPrimary = Color("#333333")
    val textSecondary = Color("#666666")
    val textMuted = Color("#999999")
    val border = Color("#EEEEEE")
    val accent = Color("#E2D1C3")
    val error = Color("#E74C3C")
    val success = Color("#2ECC71")
    val warning = Color("#F1C40F")

    val sectionLight = Color("#FDFCFB")
    val sectionMuted = Color("#F5F5F5")

    val sponsorColor = Color("#FFD700") // Gold
    val featuredColor = Color("#B19470") // Brand
    val trialColor = Color("#BDC3C7") // Silver/Grey
}

object AppStyles : StyleSheet() {
    init {
        "body" style {
            margin(0.px)
            padding(0.px)
            fontFamily("Inter", "sans-serif")
            backgroundColor(NewbornTheme.background)
            color(NewbornTheme.textPrimary)
        }

        "a" style {
            textDecoration("none")
            color(NewbornTheme.primary)
            property("transition", "all 0.2s ease")
        }
    }

    val container by style {
        maxWidth(1200.px)
        property("margin", "0 auto")
        padding(0.px, 2.cssRem)
    }

    // Navigation
    val navbar by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
        padding(1.cssRem, 2.cssRem)
        backgroundColor(NewbornTheme.surface)
        property("box-shadow", "0 2px 10px rgba(0, 0, 0, 0.05)")
        position(Position.Sticky)
        top(0.px)
        property("z-index", 1000)
    }

    val navBrand by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        cursor("pointer")

        descendant(self, type("h1")) style {
            margin(0.px)
            fontSize(1.5.cssRem)
            color(NewbornTheme.primary)
            fontWeight(700)
        }

        descendant(self, type("span")) style {
            fontSize(0.7.cssRem)
            letterSpacing(2.px)
            property("text-transform", "uppercase")
            color(NewbornTheme.textMuted)
        }
    }

    val navLinks by style {
        display(DisplayStyle.Flex)
        gap(1.5.cssRem)
        alignItems(AlignItems.Center)
    }

    val navLink by style {
        fontWeight(500)
        color(NewbornTheme.textSecondary)
        cursor("pointer")

        hover(self) style {
            color(NewbornTheme.primary)
        }
    }

    val navLinkActive by style {
        color(NewbornTheme.primary)
        property("border-bottom", "2px solid ${NewbornTheme.primary}")
    }

    // Hero
    val heroSection by style {
        padding(8.cssRem, 0.px)
        textAlign("center")
        background("radial-gradient(circle at top right, #FDFCFB, #E2D1C3)")
        marginBottom(2.cssRem)
        position(Position.Relative)
        overflow("hidden")
    }

    val sectionPadding by style {
        padding(3.cssRem, 0.px)
    }

    val sectionTitle by style {
        fontSize(1.6.cssRem)
        fontWeight(800)
        marginBottom(0.75.cssRem)
        textAlign("center")
        color(NewbornTheme.secondary)
        property("letter-spacing", "-0.5px")
    }

    val sectionSubtitle by style {
        fontSize(0.95.cssRem)
        color(NewbornTheme.textSecondary)
        textAlign("center")
        maxWidth(550.px)
        property("margin", "0 auto 2.25rem auto")
        opacity(0.8)
    }

    val heroTitle by style {
        fontSize(4.cssRem)
        marginBottom(1.5.cssRem)
        color(NewbornTheme.secondary)
        fontWeight(800)
        property("line-height", "1.1")
        property("letter-spacing", "-1px")
    }

    val heroSubtitle by style {
        fontSize(1.25.cssRem)
        color(NewbornTheme.textSecondary)
        maxWidth(750.px)
        property("margin", "0 auto")
        marginBottom(3.cssRem)
        fontWeight(400)
        property("line-height", "1.6")
    }

    // Category Cards
    val categoryGrid by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(auto-fill, minmax(220.px, 1fr))")
        gap(1.cssRem)
        marginBottom(3.cssRem)
    }

    val categoryCard by style {
        backgroundColor(NewbornTheme.surface)
        padding(1.cssRem, 1.5.cssRem)
        borderRadius(16.px)
        textAlign("left")
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        gap(1.cssRem)
        property("transition", "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)")
        border(1.px, LineStyle.Solid, NewbornTheme.border)
        cursor("pointer")
        property("box-shadow", "0 2px 8px rgba(0, 0, 0, 0.02)")

        hover(self) style {
            property("transform", "translateY(-4px)")
            property("box-shadow", "0 8px 20px rgba(0, 0, 0, 0.06)")
            property("border-color", NewbornTheme.primary.toString())

            descendant(self, type("div")) style {
                backgroundColor(NewbornTheme.primary)
                color(Color.white)
                property("transform", "rotate(10deg) scale(1.1)")
            }
        }
    }

    val categoryIcon by style {
        width(48.px)
        height(48.px)
        borderRadius(12.px)
        backgroundColor(NewbornTheme.accent)
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        fontSize(1.4.cssRem)
        color(NewbornTheme.primary)
        property("transition", "all 0.3s ease")
        flexShrink(0)
    }

    val categoryTitle by style {
        fontSize(1.1.cssRem)
        fontWeight(700)
        margin(0.px)
        color(NewbornTheme.secondary)
    }

    // Value Prop Section
    val valuePropGrid by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        flexWrap(FlexWrap.Wrap)
        gap(1.5.cssRem)
        backgroundColor(NewbornTheme.surface)
        padding(2.cssRem)
        borderRadius(20.px)
        property("box-shadow", "0 10px 40px rgba(0,0,0,0.05)")
        border(1.px, LineStyle.Solid, NewbornTheme.border)
    }

    val valueItem by style {
        flex(1)
        minWidth(200.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        textAlign("center")
        padding(1.cssRem)
        property("transition", "transform 0.3s ease")

        hover(self) style {
            property("transform", "translateY(-3px)")
        }

        descendant(self, type("h4")) style {
            fontSize(1.1.cssRem)
            fontWeight(700)
            marginBottom(0.5.cssRem)
            color(NewbornTheme.secondary)
            margin(0.px)
        }
        descendant(self, type("p")) style {
            fontSize(0.9.cssRem)
            color(NewbornTheme.textSecondary)
            property("line-height", "1.5")
            margin(0.px)
        }
    }

    val iconContainer by style {
        width(60.px)
        height(60.px)
        borderRadius(16.px)
        backgroundColor(NewbornTheme.accent)
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        fontSize(1.8.cssRem)
        marginBottom(1.2.cssRem)
        color(NewbornTheme.primary)
    }

    // Home specific sections
    val sponsorSection by style {
        backgroundColor(NewbornTheme.sectionLight)
        padding(5.cssRem, 0.px)
        borderRadius(24.px)
        marginBottom(4.cssRem)
    }

    val promoSection by style {
        padding(5.cssRem, 0.px)
        marginBottom(4.cssRem)
    }

    // Cards
    val card by style {
        backgroundColor(NewbornTheme.surface)
        borderRadius(12.px)
        padding(1.5.cssRem)
        property("box-shadow", "0 4px 6px rgba(0, 0, 0, 0.05)")
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(1.cssRem)
        property("transition", "transform 0.2s")

        hover(self) style {
            property("transform", "translateY(-4px)")
            property("box-shadow", "0 10px 15px rgba(0, 0, 0, 0.1)")
        }
    }

    val cardImage by style {
        width(100.percent)
        height(180.px)
        borderRadius(8.px)
        property("object-fit", "cover")
        backgroundColor(NewbornTheme.accent)
    }

    val cardTitle by style {
        fontSize(1.25.cssRem)
        fontWeight(600)
        margin(0.px)
    }

    val badge by style {
        padding(0.25.cssRem, 0.75.cssRem)
        borderRadius(20.px)
        fontSize(0.75.cssRem)
        fontWeight(600)
        property("text-transform", "uppercase")
    }

    // Grid
    val grid by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(auto-fill, minmax(260.px, 1fr))")
        gap(2.cssRem)
        padding(2.cssRem, 0.px)
    }

    val denseGrid by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(auto-fill, minmax(240.px, 1fr))")
        gap(1.25.cssRem)
        padding(1.5.cssRem, 0.px)
    }

    // Buttons
    val btn by style {
        padding(0.75.cssRem, 1.5.cssRem)
        borderRadius(8.px)
        fontWeight(600)
        cursor("pointer")
        border(0.px)
        property("transition", "all 0.2s")
        textAlign("center")
        display(DisplayStyle.InlineBlock)
    }

    val btnPrimary by style {
        backgroundColor(NewbornTheme.primary)
        color(NewbornTheme.surface)

        hover(self) style {
            backgroundColor(Color("#9B7E5A"))
        }
    }

    val btnSecondary by style {
        backgroundColor(NewbornTheme.secondary)
        color(NewbornTheme.surface)

        hover(self) style {
            backgroundColor(Color("#1A252F"))
        }
    }

    val btnOutline by style {
        backgroundColor(Color.transparent)
        border(2.px, LineStyle.Solid, NewbornTheme.primary)
        color(NewbornTheme.primary)

        hover(self) style {
            backgroundColor(NewbornTheme.primary)
            color(NewbornTheme.surface)
        }
    }

    // Footer
    val footer by style {
        backgroundColor(NewbornTheme.secondary)
        color(NewbornTheme.surface)
        padding(3.cssRem, 0.px)
        marginTop(4.cssRem)
        textAlign("center")
    }
}
